(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'react-emotion', './index.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-emotion'), require('./index.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactEmotion, global.index);
    global.index = mod.exports;
  }
})(this, function (exports, _react, _reactEmotion, _index) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _index2 = _interopRequireDefault(_index);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var NumberedRow = function NumberedRow(_ref) {
    var testId = _ref['data-testid'],
        rowNumber = _ref.rowNumber,
        headerText = _ref.headerText,
        children = _ref.children,
        isOptional = _ref.isOptional,
        horizontalRule = _ref.horizontalRule;

    var borderBottom = horizontalRule ? _index2.default.borderBottom : '';
    return _react2.default.createElement(
      'div',
      { className: _index2.default.numberedRowWrapper },
      _react2.default.createElement(
        'div',
        { className: _index2.default.lineItemWrapper },
        _react2.default.createElement(
          'div',
          { className: _index2.default.lineItem },
          rowNumber
        )
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _reactEmotion.cx)(_index2.default.headlineWrapper, borderBottom) },
        _react2.default.createElement(
          'span',
          { className: _index2.default.headline2 },
          headerText
        ),
        isOptional && _react2.default.createElement(
          'span',
          { className: _index2.default.optional },
          '\xA0(Optional)'
        ),
        _react2.default.createElement(
          'div',
          { className: 'pt-1' },
          children
        )
      )
    );
  };
  exports.default = NumberedRow;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/NumberedRow/index.js
// module id = 561
// module chunks = 0